<f-data-card class="pos-relative">
    <div class="container dashboard-page">

        <div class="agent-ih-list">
            <div class="row">
                <div class="col-md-12">
                    <div class="header-IH">
                        <h3 class="heading">My Interaction History</h3>
                        <div class="filter flex">
                            <button mat-button1 color="primary" class="btn-filter" title="Filters"
                                (click)="openFilter()">
                                <span *ngIf="!rootScope.isAgentFilterApplied"> <i class="fa-light fa-filter"></i>
                                </span>
                                <span *ngIf="rootScope.isAgentFilterApplied"> <i class="fa-solid fa-filter"></i> </span>
                                <span>Filters</span>
                            </button>
                            <button mat-button color="primary"
                                [ngClass]="{ disabledLink:  !rootScope.isAgentFilterApplied}"
                                [disabled]="!rootScope.isAgentFilterApplied" title="Clear Filter" class="clear-filter "
                                (click)="clearFilter()">
                                <span>Clear Filter</span>
                            </button>

                        </div>
                    </div>
                    <section class="error-wrapper" *ngIf="apiFailed">
                        <f-alert variant="error">
                            <p>
                                {{ apiFailureMsg }} <button class="btn-alert" (click)="fetchAgentInteractionData()">Try
                                    again</button>
                            </p>
                        </f-alert>

                    </section>

                    <section class="error-wrapper" *ngIf="!this.rootScope.agenIneractionData?.isAgentClientAccess">
                        <f-alert variant="error">
                            <p>
                                {{ agentClientAccessMsg }} 
                            </p>
                        </f-alert>

                    </section>

                    <div class="agent-interaction">

                        <app-alight-table *ngIf="!apiFailed"
                            [dataSource]="agentInteractionService.agentInteractionHistoryTableData"
                            [totalRecords]="totalRecords" [gridColumns]="agentInteractionService.viewColumns"
                            [rowPerPage]="10" [hideReplaceAddButton]="false" [isShowButtons]="false"
                            [isPagination]="true" [tableName]="'AgentIHView'" [sortRequired]="true"
                            (dblclick)="onDoubleClick(alightTable?.selectedRow,$event)"
                            (keydown.enter)="onTableRowEnter(alightTable?.selectedRow)"
                            
                            >
                        </app-alight-table>

                        <app-loader *ngIf="AgentIHViewLoader" [loaderType]="loaderType" [loaderMsg]="showLoaderMsg">
                        </app-loader>
                        <!-- <app-dashboard-filter class="dashboard-filter hide"
                            (setDashboardPaginationEmitter)="this.setAgentInteractionTableData"
                            *ngIf="rootScope.openFilterDialog"
                            (setDashboardPaginationEmitter)="this.setAgentInteractionTableData"></app-dashboard-filter> -->

                    </div>

                    <div class="footer-controls hide1">
                        <div class="footer-controls-left"
                            *ngIf="agentInteractionService.agentInteractionHistoryTableData.data.length > 0">
                            <p class="display-result">
                                <!-- Displaying <strong> 1-10 of 40 </strong> records -->
                                Displaying <strong>{{alightTable?.totalCount }}</strong>
                                records
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</f-data-card>